// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1SN90","dragIcon":"SortableItem_dragIcon__3ZGus","disabled":"SortableItem_disabled__1mSPX"};